import React, { forwardRef, useState } from "react";
import { Check } from "lucide-react";
// Real sr-only input for keyboard access; visible box is a peer-driven sibling.
export const CheckBox = forwardRef(({ title, className, checked, setChecked, defaultValue = false, required, small, name, disabled, ariaLabel }, ref) => {
    const isControlled = checked !== undefined;
    const [localCheck, setLocalCheck] = useState(defaultValue);
    const inputChecked = isControlled ? checked : localCheck;
    // No label → the <label> carries a 44px touch target (neutralized at sm for dense tables).
    const hasTitle = title !== undefined && title !== null && title !== "";
    return (<label className={`
                    flex items-center touch-manipulation
                    ${hasTitle ? "" : "justify-center min-h-11 min-w-11 sm:min-h-0 sm:min-w-0"}
                    ${disabled ? "cursor-not-allowed" : "cursor-pointer"} ${className ?? ""}
                `}>
                <input type="checkbox" className={"peer sr-only"} aria-label={!hasTitle ? ariaLabel : undefined} ref={ref} required={required} checked={inputChecked} name={name} disabled={disabled} 
    // setChecked and setLocalCheck are independent — chaining them in if/else froze the box when checked arrived without setChecked.
    onChange={(e) => {
            setChecked?.(e.target.checked);
            if (!isControlled) {
                setLocalCheck(e.target.checked);
            }
        }}/>

                <div className={`
                        shrink-0 flex justify-center items-center rounded-md border-2
                        peer-focus-visible:ring-2 peer-focus-visible:ring-brand-500 peer-focus-visible:ring-offset-2
                        ${disabled ? "" : "pressable"}
                        ${inputChecked ? "bg-brand-600 border-brand-600" : `bg-white border-line-strong ${disabled ? "" : "peer-hover:border-brand-400"}`}
                        ${disabled ? "opacity-50" : ""}
                        ${small ? "w-4 h-4" : "w-5 h-5"}
                    `}>
                    <Check style={{ strokeWidth: 3 }} className={`
                            text-white transition-[opacity,scale] duration-100 ease-out-soft
                            ${inputChecked ? "scale-100 opacity-100" : "scale-75 opacity-0"}
                            ${small ? "w-3 h-3" : "w-3.5 h-3.5"}
                        `}/>
                </div>

                {hasTitle && <div className={"ml-2 text-gray-900"}>{title}</div>}
            </label>);
});
//# sourceMappingURL=checkBox.jsx.map